import { Component } from "react";
import { connect } from "react-redux";
import ProgressiveImage from "react-progressive-image";
import { WEBSITE_BASE_URL } from "../../../../api";
import BackButtonWithName from "../../../Elements/BackButtonWithName";
import placeHolderImg from "../../../../assets/img/placeholder.jpeg";
import DelayLink from "react-delay-link";

export class AllPopularCategories extends Component {
  render() {
    const { categories } = this.props;

    return (
      <div style={{ padding: "16px" }}>
        <BackButtonWithName title={localStorage.getItem("all_categories")} />
        <div className="mt-3"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gap: "10px",
          }}
        >
          {categories?.categories &&
            categories?.categories.map((item, index) => (
              <div
                key={item.id}
                style={{
                  minWidth: "90px",
                  flex: "0 0 auto",
                  marginBottom: "12px",
                }}
              >
                <DelayLink to={"/single-sub-category/" + item.id} delay={300}>
                  <div
                    className="position-relative justify-content-around align-items-center"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <div
                      className="text-center"
                      style={{ background: "white" }}
                    >
                      <ProgressiveImage
                        delay={20}
                        src={WEBSITE_BASE_URL + item.image}
                        placeholder={
                          placeHolderImg
                        }
                      >
                        {(src, loading) => (
                          <div
                            style={{
                              width: "80px",
                              height: "80px",
                              margin: "0 5px",
                            }}
                          >
                            <img
                              src={src}
                              alt={item.name}
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover"
                              }}
                            />
                          </div>
                        )}
                      </ProgressiveImage>
                    </div>

                    <div
                      style={{
                        textAlign: "center",
                        marginTop: "8px",
                        fontSize: "12px",
                        fontWeight: 500,
                        width: "80px",
                      }}
                    >
                      <span style={{ fontWeight: 500 }}>
                        {localStorage.getItem("lang") === "ar"
                          ? item.arabic_name
                          : item.name}
                      </span>
                    </div>
                  </div>
                </DelayLink>
              </div>
            ))}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  categories: state.categories.categories
});

export default connect(mapStateToProps)(AllPopularCategories);
